import styled from "styled-components";
import { ButtonSettings, ArrowScroll, Text, Icon } from "../../../services/visualLibraryService";
import { shadowStyled } from "../../../styles/shared-styles";
import { i18n } from "../../../services/i18nService";

export const LayoutStyled = styled.section`
  width: 100%;
  top: 0;
  bottom: 0;
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
  /* Showing shadows when the layout has content */
  &.hasContent {
    &::before {
      pointer-events: none;
      ${props =>
        shadowStyled(
          "top",
          // "-0.5vw",
          `${props.theme.baseLayoutPaddingBs * 3}%`,
          props.theme.backgroundRGB,
          0,
          props.theme.zIndex.base
        )};
    }
  }
  /* Showing shadow inside before when the layout is scrolling */
  &.isLayoutScrolling {
    &::before {
      opacity: 1;
    }
    /* FIXME: To remove with the new layout + carousel implementation */
    article,
    article + div {
      transform: ${props => `translateY(-${props.position}px)`};
    }
  }

  ${props =>
    !props.isHeroAndBanner
      ? `
    &.noHero {
      margin-top: 8.2rem;
  `
      : ``}

  article:nth-child(2n) {
    transform: ${props => `translateY(-${props.position}px)`};
    -webkit-transform: ${props => `translateY(-${props.position}px)`};
    -ms-transform: ${props => `translateY(-${props.position}px)`};
  }
  & .Styled__ImageContainerStyled-t5q7es-1 {
    position: relative;
    width: 100%;
  }
  article.focused .selected svg {
    fill: ${props => props.theme.color.primary} !important;
  }
  & .selected span {
    opacity: 1 !important;
  }

  & .channelCarosal .slide div div:first-child img {
    margin-top: -0.5px;
    visibility: visible;
  }
  & .channelCarosal .slide.selected div div:first-child img {
    visibility: visible;
  }
`;

/* TODO: review this shadow in the new Header + Layout + carousel refactorization */
/* prettier-ignore */
export const ShadowLayoutStyled = styled.div`
  ${props =>
    shadowStyled("bottom", "1.5vw", `${props.theme.baseLayoutPaddingBs * 3}%`, '#27324E;' || props.theme.backgroundRGB, 1, props.theme.zIndex.base)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  transform: translateY(-1.8rem);
  -webkit-transform: translateY(-1.8rem);
  -ms-transform: translateY(-1.8rem);
  /* Removing shadow inside after when the layout ends */
  ${LayoutStyled}.isLayoutEnd ~ & {
    opacity: 0;
  }
`;

export const ButtonStyled = styled(ButtonSettings)`
  margin: 0 auto ${props => props.theme.spacing.xsmall};
  transform: translateY(-0.5rem);
  margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 4.167rem;
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  opacity: ${props => (props.isVisible ? 1 : 0)};
`;

export const LayoutEmptyStyled = styled.div`
  text-align: center;
  padding-top: ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const IconStyled = styled(Icon)`
  fill: ${props => props.theme.color.secondary};
  margin-bottom: 0.8rem;
  width: 2vw;
  height: 3vh;
`;
export const LayoutUpArrow = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  position: absolute;
  z-index: 30;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
`;

export const LayoutDownArrow = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  z-index: 30;
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
`;

export const UpArrow = styled.svg.attrs(props => ({
  viewBox: props.theme.components.icon.viewBox
}))`
  width: 10.5em;
  height: 4.5em;
  ${props => (props.theme.locale.dir !== "rtl" ? "margin-left:45%;" : "margin-right:45%;")}
  margin-top:15%;
  &:hover {
    margin-top: 14%;
    height: 5em;
    transition: all 0.2s;
  }
`;

export const FillBtnUpArrow = styled.path.attrs(props => ({
  d: props.theme.components.icon.list["arrowUp"].path
}))`
  fill: ${props => props.theme.color.primary};
  fill-opacity: 1;
  z-index: 15;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const DownArrow = styled.svg.attrs(props => ({
  viewBox: props.theme.components.icon.viewBox
}))`
  width: 10.5em;
  height: 4.5em;
  ${props => (props.theme.locale.dir !== "rtl" ? "margin-left:45%;" : "margin-right:45%;")}
  margin-top:10%;
  &:hover {
    margin-top: 11%;
    height: 5em;
    transition: all 0.2s;
  }
`;

export const FillBtnDownArrow = styled.path.attrs(props => ({
  d: props.theme.components.icon.list["arrowDown"].path
}))`
  fill: ${props => props.theme.color.primary};
  fill-opacity: 1;
  z-index: 15;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const HeroBanner = styled.div`
  display: flex;
  height: 8.625rem;
  width: 95.5rem;
  color: #2e2626;
  z-index: 99;
  ${props =>
    props.isActive &&
    `
      &.noHero {
        position: relative;
        margin-bottom: 2rem;
      }
    `}
  position: absolute;
  border-radius: 0.5rem;
  background-color: rgba(0, 0, 0, 0.7);
  transform: ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
      ? "translate(-2.188rem, 1.5rem)"
      : "translate(2.188rem, 1.5rem)"};
  -webkit-transform: ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
      ? "translate(-2.188rem, 1.5rem)"
      : "translate(2.188rem, 1.5rem)"};
`;

export const ContainerStyled = styled.div`
  display: flex;
  width: ${props => (props.width === 1280 ? "64%" : props.ctaTextLength >= 20 ? "60%" : "64%")};
  justify-content: flex-start;
  -webkit-align-items: center;
  -webkit-box-align: center;
  align-items: center;
  height: 100%;
  ${props =>
    props.flexTextRTL &&
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT &&
    `width: 80%;
  justify-content: flex-start;`};
`;

export const ImageBannerStyled = styled.img`
  height: 6.907rem;
`;

export const TextStyled = styled(Text)`
  font-weight: normal;
  // margin-bottom: ${props => props.theme.spacing.small};
  ${props => i18n.getLocale() === "en" && "margin-right: 0.5rem;"}
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: ${props =>
  props.theme.spacing.small};
  font-size: 1.25rem;
  // text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  ${props =>
    props.flexTextRTL &&
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT &&
    `display: flex;
  flex-direction: column;
  margin-bottom: 0`};
`;

export const ContainerButtonStyled = styled.div`
  width: ${props =>
    props.lgVersion === 3 ? "37%" : props.width === 1280 ? "36%" : props.ctaTextLength >= 20 ? "40%" : "36%"};
  ${props =>
    props.width === 1280
      ? `margin-${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}: 1.5rem`
      : ""};
  align-items: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  display: flex;
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  display: block;
  font-size: ${props => props.theme.font.size.default};
  ${props =>
    props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT
      ? `margin-right: ${props.theme.spacing.default};
         margin-left: auto;`
      : `margin-left: ${props.theme.spacing.default};
         margin-right: auto;`}
  svg {
    vertical-align: baseline;
    width: 2rem;
    height: 2rem;
    fill: #fff;
  }
`;
